import { useQuoteCalculator } from '../../../hooks/useQuoteCalculator'

interface Props {
  request: IRequest
}

const LineItem = ({ request }: Props) => {
  const cost: string | number = useQuoteCalculator(request)

  return (
    <div className="flex space-between">
      <div className="fs14 bold">{request.name}</div>
      <div className="fs14 bold">
        {!cost || isNaN(Number(cost))
          ? 'TBD'
          : `$${Number(Number(cost).toFixed(0)).toLocaleString()}`}
      </div>
    </div>
  )
}

export default LineItem
